import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export const SR_NAVBAR_TOAST_THEME_GREEN = 'SR_NAVBAR_TOAST_THEME_GREEN';
export const SR_NAVBAR_TOAST_THEME_YELLOW = 'SR_NAVBAR_TOAST_THEME_YELLOW';

const SR_NAVBAR_TOAST_THEME_TO_CLASSNAME_MAPPING = {
  [SR_NAVBAR_TOAST_THEME_GREEN]: 'green',
  [SR_NAVBAR_TOAST_THEME_YELLOW]: 'yellow',
};

const SR_NAVBAR_TOAST_THEMES = Object.keys(SR_NAVBAR_TOAST_THEME_TO_CLASSNAME_MAPPING);

const SrNavbarToast = ({
  toastContent,
  theme,
  disappear,
}) => (
  <div
    className={classnames('navbar-toast', SR_NAVBAR_TOAST_THEME_TO_CLASSNAME_MAPPING[theme], {
      disappear,
    })}
  >
    <span>
      {toastContent}
    </span>
  </div>
);

SrNavbarToast.displayName = 'SrNavbarToast';

SrNavbarToast.propTypes = {
  theme: PropTypes.oneOf(SR_NAVBAR_TOAST_THEMES),
  disappear: PropTypes.bool,
};

SrNavbarToast.defaultProps = {
  theme: SR_NAVBAR_TOAST_THEME_GREEN,
  disappear: true,
};

export default SrNavbarToast;
